import { quickEntries } from "@/mocks/movieData";
import SectionHeading, { Section } from "./SectionHeading";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const iconStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-900",
  "bg-secondary-100 text-secondary-900",
  "bg-background-200 text-foreground-800",
];

export default function QuickEntry() {
  const { ref, visible } = useScrollReveal<HTMLDivElement>();

  return (
    <Section id="entry" className="bg-background-50">
      <SectionHeading
        eyebrow="从这里开始"
        title="先弄清楚你要的是哪一步，再动手"
        description="不同需求对应的入口不一样。下面把最常见的四类需求拆开说明，点击卡片上的按钮可以跳到对应分区的详细内容。"
      />

      <div
        ref={ref}
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 section-reveal ${visible ? "is-visible" : ""}`}
      >
        {quickEntries.map((entry, index) => (
          <article
            key={entry.id}
            className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 hover:border-primary-300 transition-colors"
          >
            <span
              className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg ${iconStyles[index % iconStyles.length]}`}
            >
              <i className={`${entry.icon} text-2xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{entry.desc}</p>
            <a
              href={entry.href}
              className="mt-4 inline-flex items-center gap-1 text-sm font-label text-primary-700 hover:text-primary-800 transition-colors cursor-pointer"
            >
              {entry.action}
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </article>
        ))}
      </div>
    </Section>
  );
}